export default __webpack_public_path__ + "static/media/logo.ee12c551.png";